import React from 'react';
/** @jsxRuntime classic */

/** @jsx jsx */

import { jsx, css } from '@emotion/core';
import { useTheme } from 'emotion-theming';
import { userWeb, phytosanitaryWeb, migratoryWebCitizen, sanitarianRegistersWeb, tdCarWeb } from '../Colors';
import { ArrowLeftIcon } from '../../icon';
import { mediaQuery } from '../../utils';
/**
 * This component represents a back link.
 * @param {function} history History from react router dom.
 * @param {function} onClick Function triggered when the user clicks the back button.
 * @param {string} children Back button text.
 * @param {string} className Used to apply predetermine styles for the div that wraps the back button.
 * @param {props} navigate All other suppported props.
 */

export default /*#__PURE__*/React.memo(({
  history,
  onClick,
  children = 'Volver',
  className = '',
  ...props
}) => {
  const {
    theme
  } = useTheme();
  return jsx("div", {
    role: "link",
    tabIndex: "0",
    onClick: onClick || history.goBack,
    onKeyDown: e => {
      if (e.key === 'Enter') {
        if (typeof onClick !== 'undefined') {
          onClick();
        } else {
          history.goBack();
        }
      }
    },
    css: backStyle({
      theme
    }),
    style: props.style,
    className: className
  }, jsx(ArrowLeftIcon, {
    className: "icon",
    css: {
      width: 23,
      height: 19
    }
  }), jsx("span", null, children));
});
const themes = {
  home: {
    alpha: userWeb.fireEngineRed,
    beta: userWeb.fireEngineRed
  },
  phytosanitaryWeb: {
    alpha: phytosanitaryWeb.salem,
    beta: phytosanitaryWeb.salem
  },
  migratoryWebCitizen: {
    alpha: migratoryWebCitizen.fireEngineRed,
    beta: migratoryWebCitizen.fireEngineRed
  },
  sanitarianRegistersWeb: {
    alpha: sanitarianRegistersWeb.fireEngineRed,
    beta: sanitarianRegistersWeb.fireEngineRed
  },
  tdCarWeb: {
    alpha: tdCarWeb.fireEngineRed,
    beta: tdCarWeb.fireEngineRed
  }
};

function backStyle({
  theme = 'home'
}) {
  return css`
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    ${mediaQuery[0]} {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 20px;
    }

    .icon {
      margin-right: 10px;
      width: 23px;
      height: 19px;
      color: ${themes[theme].beta};
      ${mediaQuery[0]} {
        width: 16px;
        height: 16px;
      }
    }

    span {
      font-style: normal;
      font-weight: normal;
      font-size: 16;
      color: ${themes[theme].alpha};
    }
  `;
}